export default "__VITE_ASSET__dec588fd__"